import React from 'react';
import PropTypes from 'prop-types';
import DnDItemTypes from './DnDItemTypes';

const DraggedAnswerPreview = ({ selectedPreviewItems, nodeType }) => {
  const renderDictionaryPreview = () =>
    selectedPreviewItems.map(item => (
      <div key={item.node} className="dragged-preview-item">
        {item.shortText}
      </div>
    ));

  const renderTargetsPreview = () =>
    selectedPreviewItems.map(item => (
      <div key={item.expressionId} className="dragged-preview-item">
        {item.title}
      </div>
    ));

  return (
    <div className="row">
      <div className="large-6 columns dragged-preview-grid">
        {nodeType === DnDItemTypes.DnD_ITEM_TYPE_2
          ? renderDictionaryPreview()
          : renderTargetsPreview()}
      </div>
    </div>
  );
};

DraggedAnswerPreview.propTypes = {
  selectedPreviewItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  nodeType: PropTypes.string,
};

export default DraggedAnswerPreview;
